<script setup lang="ts">
import type { ComponentStyles } from 'types/index';
import type { EmployeeData } from 'types/blocks';

defineProps<{
  data: EmployeeData;
  componentStyles: ComponentStyles;
}>();
</script>

<template>
  <BaseComponentWrapper
    :component-styles="componentStyles"
    :bg-fallback="'bg-tertiary'"
  >
    <PartialsEmployeeList :data="data" />
  </BaseComponentWrapper>
</template>
